export default {
  navigationBarTitleText: '预览-web',
};
